import { Button, Callout, Tag } from '@dev-spendesk/grapes';

import { useFeature } from '../../../common/hooks/useFeature';
import { useTranslation } from '../../../common/hooks/useTranslation';
import FEATURES from '../../../constants/features';
import { useCompanyId } from '../../app/hooks/useCompanyId';
import { useUser } from '../../app/hooks/useUser';
import { NotificationType, useNotifications } from '../../app/notifications';
import { useUpdateKycReview, useGetWiseKycStatus } from '../transfer/hooks';

export function WiseIntegrationReminderBanner() {
  const { t } = useTranslation('global');

  const companyId = useCompanyId();

  const user = useUser();

  const isUserOwner = user.is_account_owner || user.is_organisation_owner;

  const isUserController = user.is_controller;

  const hasUkInternationalWiretransferFeature = useFeature(
    FEATURES.TMP_UK_INTERNATIONAL_WIRE_TRANSFER,
  );

  const { data: kycStatus } = useGetWiseKycStatus({
    companyId,
    enabled: hasUkInternationalWiretransferFeature,
  });

  const { pushNotif } = useNotifications();

  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const { mutateAsync: createKycReview } = useUpdateKycReview({
    companyId,
    redirectUserTo: `${baseUrl}/app/${companyId}/company/integrations/all/wise?status=success`,
  });

  const handleGoToWiseButton = async () => {
    try {
      const { redirectUrl } = await createKycReview();

      window.open(redirectUrl, '_blank');
    } catch {
      pushNotif({
        type: NotificationType.Danger,
        message: t('wiseIntegrationLandingPage.errorNotificationRedirectTitle'),
      });
    }
  };

  if (
    !hasUkInternationalWiretransferFeature ||
    !isUserOwner ||
    !isUserController
  ) {
    return null;
  }

  if (kycStatus !== 'WAITING_CUSTOMER_INPUT') {
    return null;
  }

  return (
    <Callout
      title={
        <span className="flex flex-row">
          <p>{t('invoices.transfer.wiseIntegrationBanner.title')}</p>
          <Tag className="ml-12" variant="ocean">
            {t('misc.new')}
          </Tag>
        </span>
      }
    >
      <div className="flex flex-col gap-16">
        <p className="white-space-pre-wrap">
          {t('invoices.transfer.wiseIntegrationBanner.body1')}
        </p>

        {isUserOwner ? (
          <>
            <p>{t('invoices.transfer.wiseIntegrationBanner.body2')}</p>
            <Button
              className="self-start"
              text={t('invoices.transfer.wiseIntegrationBanner.button')}
              onClick={handleGoToWiseButton}
            />
          </>
        ) : (
          <p>{t('invoices.transfer.wiseIntegrationBanner.body2Controller')}</p>
        )}
      </div>
    </Callout>
  );
}
